export default __webpack_public_path__ + "static/Sunlight-b44b0b18b97080cbfe0b21774075cd56.png";